import {
  DRAG_DROP_SORT_STRATEGY,
  DragDropProvider,
  DragDropSortableList,
} from '../../DragDrop'

function TableDnDSortableBody({ children, droppableProps, ...restProps }) {
  const ids = droppableProps?.items.map(i => i.id.toString())

  return (
    <DragDropProvider
      {...restProps}
      overlayProps={droppableProps?.overlayProps}
      renderOverlay={droppableProps?.renderOverlay}
      onDragEnd={droppableProps?.onDragEnd}
      onDragOver={droppableProps?.onDragOver}
    >
      <DragDropSortableList
        items={ids}
        strategy={DRAG_DROP_SORT_STRATEGY.vertical}
      >
        {children}
      </DragDropSortableList>
    </DragDropProvider>
  )
}

export default TableDnDSortableBody
